// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_ATTACHMENT_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, '')(dispatch);

        }

    };

export const updateAttachmentClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_ATTACHMENT_PROPERTY,
    value
});

export const updateAttachmentClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_ONE,
    workOrder
});

export const updateAttachmentClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_ATTACHMENT_WORK_ORDER_TWO,
    workOrder
});

export const updateAttachmentClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_ATTACHMENT_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_ATTACHMENT_OWNERSHIP_STATUS
});

export const updateAttachmentClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_ATTACHMENT_FAILURE_PART
});

export const updateAttachmentClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_ATTACHMENT_FAILURE_DATE
});

export const updateAttachmentClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_ATTACHMENT_REPAIR_DATE
});

export const updateAttachmentClaimInputOnBlur = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_ATTACHMENT_FORM_VALIDATION,
    validity: mapFormValidation(property, value)
});

export const resetAttachmentClaim = () => ({
    type: actions.RESET_CLAIM_ATTACHMENT
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_ATTACHMENT_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/claim-details.js